import React, { lazy, Suspense, useCallback, useEffect, useRef, useState } from 'react';
import { Hero } from './components/sections/Hero';
import { Testimonials } from './components/sections/Testimonials';
import { SocialStats } from './components/sections/SocialStats';
import { Pain } from './components/sections/Pain';
const DeferredContent = lazy(() => import('./components/sections/DeferredContent').then(({
  DeferredContent: Content
}) => ({
  default: Content
})));
const SocialProofToast = lazy(() => import('./components/SocialProofToast').then(({
  SocialProofToast: Toast
}) => ({
  default: Toast
})));
export function App() {
  const deferredTriggerRef = useRef<HTMLDivElement>(null);
  const [shouldLoadDeferred, setShouldLoadDeferred] = useState(false);
  const [isDeferredReady, setIsDeferredReady] = useState(false);
  const [shouldFocusPricing, setShouldFocusPricing] = useState(false);
  const [shouldShowSocialProof, setShouldShowSocialProof] = useState(false);
  const revealPricing = useCallback(() => {
    setShouldFocusPricing(true);
    setShouldLoadDeferred(true);
  }, []);
  const markDeferredReady = useCallback(() => {
    setIsDeferredReady(true);
  }, []);
  useEffect(() => {
    const socialProofTimer = window.setTimeout(() => setShouldShowSocialProof(true), 2400);
    return () => window.clearTimeout(socialProofTimer);
  }, []);
  useEffect(() => {
    const trigger = deferredTriggerRef.current;
    if (!trigger) return undefined;
    if (!('IntersectionObserver' in window)) {
      setShouldLoadDeferred(true);
      return undefined;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      setShouldLoadDeferred(true);
      observer.disconnect();
    }, {
      rootMargin: '280px 0px'
    });
    observer.observe(trigger);
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    if (!shouldFocusPricing || !isDeferredReady) return;
    const frame = window.requestAnimationFrame(() => {
      const pricing = document.getElementById('pricing');
      if (!pricing) return;
      pricing.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      window.setTimeout(() => document.getElementById('pricing-title')?.focus(), 350);
      setShouldFocusPricing(false);
    });
    return () => window.cancelAnimationFrame(frame);
  }, [isDeferredReady, shouldFocusPricing]);
  return <main className="w-full min-h-full bg-cream text-cocoa" data-id="element-0" data-mp="3gkuy3jvs9b9l">
      <Hero onCta={revealPricing} data-id="element-1" data-mp="3gj1t090tiz3p" />
      <Testimonials data-id="element-2" data-mp="3bmtft166lfz6" />
      <SocialStats data-id="element-3" data-mp="3bnmgpliglb9e" />
      <Pain data-id="element-4" data-mp="3bo4mp9uxb3ui" />
      <div ref={deferredTriggerRef} className="h-px" aria-hidden="true" data-id="element-5" data-mp="3bk72sm0iu89k" />
      {shouldLoadDeferred && <Suspense fallback={<div className="min-h-px" aria-hidden="true" data-id="element-7" data-mp="3lkhf84eqfbno" />} data-id="element-6" data-mp="3qdajysa7ajzr">
          <DeferredContent onCta={revealPricing} onReady={markDeferredReady} data-id="element-8" data-mp="3liwlui45lyre" />
        </Suspense>}
      {shouldShowSocialProof && <Suspense fallback={null} data-id="element-9" data-mp="2xssj0cysi31g">
          <SocialProofToast data-id="element-10" data-mp="2swbtpffutims" />
        </Suspense>}
    </main>;
}